import { getCheckoutAppShell } from '@/utils/checkout-app-shell'

const listeners = new Map()

export const EventBus = {
  $on (type, fn) {
    if (!listeners.has(type)) listeners.set(type, new Set())
    listeners.get(type).add(fn)
  },
  $off (type, fn) {
    if (type == null) {
      listeners.clear()
      return
    }
    const set = listeners.get(type)
    if (!set) return
    if (fn) {
      set.delete(fn)
      if (set.size === 0) listeners.delete(type)
    } else {
      listeners.delete(type)
    }
  },
  $emit (type, payload) {
    const set = listeners.get(type)
    if (!set) return
    for (const handler of [...set]) {
      handler(payload)
    }
  },
  $once (type, fn) {
    const wrap = (payload) => {
      EventBus.$off(type, wrap)
      fn(payload)
    }
    EventBus.$on(type, wrap)
  },
  setPrevHeight () {
    const el = getCheckoutAppShell()
    if (el) el.$prevHeight = el.clientHeight + 'px'
  }
}
